<template>
  <div id="outdiv">
    <div class="left_div">
      <div class="widt_160">
        <div class="parent_li" v-for="item in productList" :key="item.id">
          <span class=" titname ">{{item.name}}</span>
          <div class="child_name " :class="{ active:unit==isActive}" @click="handleNodeClick(unit) " v-for='unit in item.child' :key='unit.id'>{{unit.name}}</div>
        </div>
        <div class="bottom_border "></div>
        <div class="now_rap ">
          <p class="titname ">商务合作</p>
          <p class="phonenumber ">4001118130-3</p>
        </div>
      </div>
    </div>
    <div class="right_div " v-show="Pznow ">
      <div class="context " v-for="val in protree " :key="val.id ">
        <h5 class="supername " v-if="val.name ">{{val.name}}</h5>
        <p class="text_p " v-if="val.detail ">{{val.detail}}</p>
      </div>
      <div v-for="item in produetType " :key="item.id ">
        <div class="border_solid "></div>
        <p class="protype_name ">{{item.name}}</p>
        <div class="bottom_div ">
          <div class="img_div " v-for="pro in item.product " :key="pro.id " :title="pro.detail ">
            <img :src="pro.pic_file " width="160 " height="160 " />
            <p class="typename ">{{pro.name}}</p>
            <div class="detail_name ">
              <div class="detali_text " v-html="pro.detail.replace(/\n/g, '<br>') "></div>
            </div>
          </div>
        </div>
        <div class="nodata " v-show="showname ">
          <div> <img src="../../../common/img/product_null.png"> </div>
          <p class="wz ">敬请期待...</p>
        </div>
      </div>
    </div>

    <div class="right_div " v-show="proShow ">
      <div v-for="item in produet " :key="item.id ">
        <div class="context ">
          <h5 class="supername ">{{item.name}}</h5>
          <p class="text_p ">{{item.detail}}</p>
        </div>
        <div class="border_solid "></div>
        <div v-for="val in item.child " :key="val.id ">
          <p class="protype_name ">{{val.name}}</p>
          <div class="bottom_div ">
            <div class="img_div " v-for="pro in val.product " :key="pro.id " :title="pro.detail ">
              <img :src="pro.pic_file " width="160 " height="160 " />
              <p class="typename ">{{pro.name}}</p>
              <div class="detail_name ">
                <div class="detali_text " v-html="pro.detail.replace(/\n/g, '<br>') "></div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="nodata " v-show="showname ">
          <div> <img src="../../../common/img/product_null.png "> </div>
          <p class="wz ">敬请期待...</p>
        </div> -->
      </div>
    </div>
  </div>
</template>
<style lang='scss'>
@import 'znyj';
</style>
<script>
import { getProTree, getProClass } from '@/api/portal';
export default {
  data() {
    return {
      produetType: [], //产品分类(右边列表)
      productList: [], //产品类型(左边菜单)
      produet: [], //父级导航栏点击调用
      protree: [],
      type: '',
      page_index: 1,
      page_size: 10,
      total: 0,
      super_id: '',
      id: '',
      val: '',
      showname: false,
      isShow: false,
      proShow: false, //父级导航栏点击跳转获取子级数据
      Pznow: true, //当前页面点击父级下的自己获取数据
      isActive: false,
    };
  },
  components: {
    // Thenewlist,
  },
  methods: {
    //获取产品类型树
    _getList() {
      getProTree({})
        .then(res => {
          this.productList = res.data;
          this.id = res.data[0].id;
          this.handleNodeClick({
            id: res.data.child.id,
            super_id: res.data[0].id,
          });
        })
        .catch(err => {});
    },
    //获取产品分类列表
    get(data) {
      getProClass({
        type: data.super_id,
      })
        .then(res => {
          this.protree = res.data;
          // if (res.data[0].product == '') {
          //   this.showname = true;
          // } else {
          //   this.showname = false;
          // }
        })
        .catch(err => {});
    },
    handleNodeClick(data) {
      this.isActive = data;
      this.proShow = false;
      this.Pznow = true;
      this.get(data);
      getProClass({
        type: data.id,
      })
        .then(res => {
          this.produetType = res.data;
          if (res.data[0].product == '') {
            this.showname = true;
          } else {
            this.showname = false;
          }
        })
        .catch(err => {});
    },
    //获取产品分类"(父级)
    _getTree() {
      this.isActive = false;
      getProClass({
        type: this.id,
      })
        .then(res => {
          this.produet = res.data;
        })
        .catch(err => {});
    },
  },
  watch: {
    $route(route) {
      this.id = route.query.id;
      if (this.id != '') {
        this.proShow = true;
        this.Pznow = false;
        this._getTree();
      } else {
        this.Pznow = true;
      }
    },
  },
  created() {
    this.id = this.$route.query.id;
    if (this.id != '') {
      this.proShow = true;
      this.Pznow = false;
      this._getTree();
    } else {
      this.Pznow = true;
    }
    // this._getCaseType();
    this._getList();
  },
};
</script>